import { fetchAuthSession } from "aws-amplify/auth";
import { SystemError, SystemErrorTitle, SystemErrorMsg } from "../../constants";
import executeApi from './executeApi';
import { GetKigyoCountApiRequest } from "../model/apiRequestModel";
import { GetKigyoCountApiResponse } from "../model/apiResponseModel";

/** 企業件数取得 */
const getKigyoCount = async (requestObj: GetKigyoCountApiRequest): Promise<GetKigyoCountApiResponse> => {
    // 認証
    const session = await fetchAuthSession();
    const jwtToken = session.tokens?.idToken?.toString();
    // EyesFrontAPIのURLを取得
    const baseURL = process.env.REACT_APP_EYES_FRONT_API_ROOT!;
    // 企業件数取得API PATH
    const path = "/search/count/execution";
    const request = JSON.stringify(requestObj)

    try {
        const response = await executeApi(baseURL, path, jwtToken, 0, request);
        // レスポンスコード返却
        if (!response || response.data.res_cd == "") {
            return {
                resCd: SystemError,
                msgTitle: SystemErrorTitle,
                msg: SystemErrorMsg
            }
        } else {
            const result: GetKigyoCountApiResponse = response.data
            return result
        }
    } catch (e) {
        return {
            resCd: SystemError,
            msgTitle: SystemErrorTitle,
            msg: SystemErrorMsg
        };
    }
};

export default getKigyoCount;
